<template>
  <div>
    <vs-card class="email-card">
      <!-- {{CurrentEmailData}} -->
      <h4 v-if="CurrentEmailData.root_email">Subject : {{ emailSubject }}</h4>
      <vs-divider />

      <!-- Root Email (MAIN Email) DetailsView -->
      <div class="">
        <ul>
          <li
            v-for="(each_thread, index) in CurrentEmailData.root_email"
            :key="index"
          >
            <div class="cstm-email-collapse">
              <div
                class="flex justify-between flex-wrap items-center"
                slot="header"
              >
                <div class="flex items-center flex-wrap">
                  <vs-avatar
                    class="border-2 border-solid border-white"
                    :src="each_thread.from_user.picture"
                    size="40px"
                  />
                  <p class="thread_all_recipients">
                    <b
                      >{{ each_thread.from_user.first_name }}
                      {{ each_thread.from_user.last_name }}</b
                    >
                  </p>
                  <!-- <p class="mail-info font-sm">&#60;{{each_thread.allRecipients}}&#62;</p> -->
                  <div class="all-mail-info">
                    <a class="flex relative">
                      to&nbsp;
                      <span>{{
                        each_thread.allRecipients.replace(/(.{10})..+/, "$1…")
                      }}</span>
                      <span
                        v-if="
                          each_thread.allRecipients.length > 0 &&
                          each_thread.allExternalUsers.length > 0
                        "
                        >,&nbsp;
                      </span>
                      <span>{{
                        each_thread.allExternalUsers.replace(
                          /(.{10})..+/,
                          "$1…"
                        )
                      }}</span>

                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4 ml-1"
                      />

                      <div class="inner-info">
                        <table>
                          <tr>
                            <th>from:</th>
                            <td>
                              {{ each_thread.from_user.first_name }}
                              {{ each_thread.from_user.last_name }}
                            </td>
                          </tr>
                          <tr>
                            <th>to:</th>
                            <td>
                              <span>{{ each_thread.allRecipients }}</span>
                              <span
                                v-if="
                                  each_thread.allRecipients.length > 0 &&
                                  each_thread.allExternalUsers.length > 0
                                "
                                >,&nbsp;
                              </span>
                              <span>{{ each_thread.allExternalUsers }}</span>
                            </td>
                          </tr>
                          <tr>
                            <th>date:</th>
                            <td>
                               {{
                                each_thread.created_at
                                  | dateFormatLocalization
                              }}
                              {{
                                each_thread.created_at
                                  | timeFormatLocalization
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th>subject:</th>
                            <td>{{ each_thread.subject }}</td>
                          </tr>
                        </table>
                      </div>
                    </a>
                  </div>
                </div>
                <div>
                  <p class="mx-3 font-sm">
                    {{ each_thread.created_at | moment("from") }}
                  </p>
                </div>
              </div>
              <div class="inner-collapse">
                <p class="thread_body" v-html="each_thread.body"></p>
              </div>
            </div>
            <vs-divider />
          </li>
        </ul>
      </div>

      <!-- Thread Email (Reply Email) DetailsView -->
      <div
        class="thread-card"
        v-if="CurrentEmailData.thread_email.length === 0"
      >
        <p>No New Thread Found</p>
      </div>
      <div class="" v-else>
        <ul>
          <li
            v-for="(each_thread, index) in CurrentEmailData.thread_email"
            :key="index"
          >
            <div class="cstm-email-collapse">
              <div
                class="flex justify-between flex-wrap items-center"
                slot="header"
              >
                <div class="flex items-center flex-wrap">
                  <vs-avatar
                    class="border-2 border-solid border-white"
                    :src="each_thread.from_user.picture"
                    size="40px"
                  />
                  <p class="thread_all_recipients">
                    <b>{{each_thread.from_user.first_name}} {{each_thread.from_user.last_name}}</b>
                  </p>
                  <!-- <p class="mail-info font-sm">&#60;{{each_thread.allRecipients}}&#62;</p> -->
                  <div class="all-mail-info">
                    <a class="flex relative">
                      to&nbsp;
                      <span>{{
                        each_thread.allRecipients.replace(/(.{10})..+/, "$1…")
                      }}</span>
                      <span
                        v-if="
                          each_thread.allRecipients.length > 0 &&
                          each_thread.allExternalUsers.length > 0
                        "
                        >,&nbsp;
                      </span>
                      <span>{{
                        each_thread.allExternalUsers.replace(
                          /(.{10})..+/,
                          "$1…"
                        )
                      }}</span>
                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4 ml-1"
                      />

                      <div class="inner-info">
                        <table>
                          <tr>
                            <th>from:</th>
                            <td>{{ each_thread.from_user.first_name }} {{ each_thread.from_user.last_name }}</td>
                          </tr>
                          <tr>
                            <th>to:</th>
                            <td>
                              <span>{{ each_thread.allRecipients }}</span>
                              <span
                                v-if="
                                  each_thread.allRecipients.length > 0 &&
                                  each_thread.allExternalUsers.length > 0
                                "
                                >,&nbsp;
                              </span>
                              <span>{{ each_thread.allExternalUsers }}</span>
                            </td>
                          </tr>
                          <tr>
                            <th>date:</th>
                            <td>
                              {{
                                each_thread.created_at
                                  | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                              }}
                            </td>
                          </tr>
                          <tr>
                            <th>subject:</th>
                            <td>{{ each_thread.subject }}</td>
                          </tr>
                        </table>
                      </div>
                    </a>
                  </div>
                </div>
                <div>
                  <p class="mx-3 font-sm">
                    {{ each_thread.created_at | moment("from") }}
                  </p>
                </div>
              </div>
              <div class="inner-collapse">
                <p class="thread_body" v-html="each_thread.body"></p>
              </div>
            </div>
            <vs-divider />
          </li>
        </ul>
      </div>

      <vs-button size="medium" class="reply-btn" @click="initiateEmailReply()">
        <span class="material-icons mr-2">reply</span>
        Reply
      </vs-button>

      <div class="mt-4 reply-texteditor" v-if="openReplyTextEditor">
        <!-- {{replyEmailBody}} -->
        <editor
          output-format="html"
          v-model="replyEmailBody"
          :api-key="tinyMceApi"
          :init="initTinyMce"            
        />

        <vs-button
          class="mt-4 compose-btns"
          @click="sendReply()"
          color="primary"
          type="filled"
          icon="send"
          size="large"
        ></vs-button>
      </div>
    </vs-card>
    <div v-if="isBrowseContent">
      <vs-popup
        fullscreen
        title="Browse Item"
        :active.sync="isBrowseContent"
        class="childImportPopUp"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
        <!-- <div slot="footer">jfjfjf</div> -->
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Bell from './Bell'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import {
  getSentEmailThread,
  getInboxEmailThread,
  sendSaveEmail
} from '@/api/communication'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import { GoogleAuthorization } from '@/mixins/common/GoogleAuthorization.js'
import { getRepositoryDetails } from '@/api/message'
import { getUploadedFilesId } from '@/api/assignment-question'
import { contentFileUpload} from '@/api/course-builderapi'

export default {
  name: 'Email_Details',
  components: {
    Bell,
    editor: Editor,
    vSelect,
    ImportBrowseFilesModel
  },
  mixins: [GoogleAuthorization],
  data () {
    return {
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon('filesIcon', '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>')
          editor.ui.registry.addIcon('gDriveIcon', '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>')
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive', 
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 500,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
                  'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
                        table alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'
      },
      file_repository_id: '',
      editorComponent: null,
      isBrowseContent: false,
      isCollapseCard: false,
      CurrentEmailData: {
        thread_email: [],
        root_email: []
      },
      email_id: '',
      details_page_type: '',
      emailSubject: '',
      emailBody: '',
      replyEmailBody: '',
      to_users: '',
      user_type: '', //From User Type
      from_user: '',
      from_user_type: '1',
      replyEmailPayload: '',
      openReplyTextEditor: false,
      example_image_upload_handler: '',
      image_url: '',
      tinyMceApi: ''
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    this.image_url = `http://cx-lms-api-dev.track-progress.com/api/file/upload/${customer_id}`
  },
  computed: {},
  mounted () {
    this.getRepositoryDetails()
    this.email_id = this.$route.params.email_id
    this.details_page_type = this.$route.params.details_page_type
    this.getEmailThread(this.details_page_type, this.email_id)
  },
  methods: {    
    images_upload_handler (blobInfo, success, failure) {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress(e.loaded / e.total * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${  xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${  xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${  xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(`Image upload failed due to a XHR Transport error. Code: ${  xhr.status}`)
      }

      xhr.setRequestHeader('Authorization', `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`)


      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())

      

      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data =  this.fileupload(formData)

      data.then(res => {
        
        const locationObject = {
          src:{
            value:{
              location:res
            }
          }
        }

        const stringify = JSON.stringify(res)
        const parse = JSON.parse(stringify)
        
        success(parse)
      }).catch(error => {
        
      })

    },

    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')

        const responseImage = await contentFileUpload(customer_id, payload)
        const location = responseImage.data.data.cdn + responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title:'Success',
          text: 'Image Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color:'success',
          time: 3000
        })
        return (location)
      } catch (error) {
        
      }
    },
    async getRepositoryDetails () {
      const payload = {
        platform_module_id: '39'
      }
      const customer_id = localStorage.getItem('customer_id')
      const data = await getRepositoryDetails(customer_id, payload)
      //
      //
      this.file_repository_id = data.data.data[0].id
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    },
    gDrive (editor) {
      this.editorComponent = editor
      this.driveIconClicked()
    },
    getImportFile ({ file_id, fileInfo }) {
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(
          `<img src="${eachFile.file_path}" width="auto" height="auto"/>`
        )
      })
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await getUploadedFilesId(file_id_payload)

      // console.log()
      const filesDriveInfo = res.data.data.files
      if (type === 'drive') {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split('/')[0] === 'image') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'video') {
            this.editorComponent.insertContent(
              `<video width="200" height="300"<source src="${eachFile.file_path}"</video>`
            )
          } else if (eachFile.file_type.split('/')[0] === 'audio') {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            )
          }
        })
        console.log(filesDriveInfo)
      }
    },
    initiateEmailReply () {
      this.replyEmailBody = ''
      this.openReplyTextEditor = !this.openReplyTextEditor
    },
    getAllRecipients (emailListData) {
      // eslint-disable-next-line no-unused-vars
      emailListData.forEach(function (value, key) {
        // eslint-disable-next-line no-unused-vars
        value.allRecipients = ''
        value.allRecipients_admin_staff = ''
        value.allRecipients_clients = ''
        let allRecipientsArr_admin_staff = []
        let allRecipientsArr_clients = []
        let allRecipientsArr_parents = []
        value.to_admin_or_staff_users.forEach(function (value1, key2) {
          allRecipientsArr_admin_staff = value.to_admin_or_staff_users.map(
            (value1) => {
              if (value1.user !== null) {
                return `${value1.user.first_name} ${value1.user.last_name}`
              }
            }
          )
        })
        value.to_client_users.forEach(function (value1, key2) {
          allRecipientsArr_clients = value.to_client_users.map((value1) => {
            if (value1.client_user !== null) {
              return `${value1.client_user.first_name} ${value1.client_user.last_name}`
            }
          })
        })
        value.to_parent_users.forEach(function (value1, key2) {
          allRecipientsArr_parents = value.to_parent_users.map((value1) => {
            if (value1.client_user !== null) {
              return `${value1.client_user.first_name} ${value1.client_user.last_name}`
            }
          })
        })
        value.allRecipients = allRecipientsArr_admin_staff
          .concat(allRecipientsArr_parents)
          .concat(allRecipientsArr_clients)
          .join(', ')

        if (value.external_users !== null) {
          // value.isCollapseCard = false
          const allExternalUsersArr = value.external_users.map((value1) => {
            return value1.email
          })
          value.allExternalUsers = allExternalUsersArr.join(', ')
        } else {
          value.allExternalUsers = ''
        }
      })
    },
    async getEmailThread (details_page_type, email_id) {
      const payload = {
        id: email_id
      }
      const customer_id = localStorage.getItem('customer_id')

      let data = ''
      if (details_page_type === 'sent') {
        data = await getSentEmailThread(customer_id, payload)
      } else if (details_page_type === 'inbox') {
        data = await getInboxEmailThread(customer_id, payload)
      }

      this.CurrentEmailData = data.data.data
      this.getAllRecipients(this.CurrentEmailData.thread_email)
      this.getAllRecipients(this.CurrentEmailData.root_email)
      this.to_users = this.CurrentEmailData.root_email[0].to_users
      this.user_type = this.CurrentEmailData.root_email[0].user_type //From User Type
      this.from_user = this.CurrentEmailData.root_email[0].from_user
      this.emailSubject = this.CurrentEmailData.root_email[0].subject
      this.emailBody = this.CurrentEmailData.root_email[0].body
      this.email_id = this.CurrentEmailData.root_email[0].id

      //Automatically creating thread for this email
      //this.sendReply()
    },
    async sendReply () {
      this.from_user.is_root_user = 0
      this.from_user.to_user_id = this.from_user.id
      this.from_user.to_user_type = this.user_type

      const emailPayload = {
        from_user_type: this.from_user_type,
        is_parent_thread: 0,
        thread_id: this.email_id,
        subject: this.emailSubject,
        body: this.replyEmailBody,
        to_users: [...this.CurrentEmailData.root_email[0].to_users],
        email_type: 1
      }
      //
      //
      this.replyEmailPayload = emailPayload

      try {
        //this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        // eslint-disable-next-line no-unused-vars
        const data = await sendSaveEmail(customer_id, emailPayload)
        //

        this.getEmailThread(this.details_page_type, this.email_id)
        this.initiateEmailReply()

        this.$vs.notify({
          title: 'Success',
          text: 'Email Sent Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        let errorText = ''
        if (error.data.errors.body) {
          errorText = 'Body is required'
        } else if (error.data.errors.to_users) {
          errorText = 'To users is required'
        } else if (error.data.errors.subject) {
          errorText = 'Subject is required'
        }

        this.$vs.notify({
          title: 'Error',
          text: errorText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } finally {
        //this.$vs.loading.close()
      }
    }
  }
}
</script>

<style>
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
}
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.read {
  background-color: transparent !important;
  font-weight: 500;
}
.email-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
}
.email-card {
  position: relative;
}
.compose-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.email-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.email-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.email-form input,
.email-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}

@media (max-width: 360px) {
  .email-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.thread_subject {
  font-weight: 600;
}

.thread_all_recipients {
  color: #222;
}

.thread_body {
  padding: 0 1rem;
}
.thread-card {
  margin-top: 10px;
  padding: 10px;
}
.cstm-email-collapse .mail-info {
  margin-left: 10px;
}
.cstm-email-collapse .vs-collapse-item--header {
  padding: 0 1rem !important;
}
.cstm-email-collapse .con-content--item {
  padding: 1rem 1rem 0 !important;
}
.font-sm {
  font-size: 12px;
}
.all-mail-info {
  width: 100%;
  margin-top: -10px;
  padding-left: 50px;
  display: flex;
  font-size: 11px;
  /* font-weight: bold; */
}
.inner-collapse {
  position: static;
  z-index: 1;
  padding: 1rem;
}
.all-mail-info .inner-info {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: absolute;
  display: none;
  left: 80%;
  top: 100%;
  background: #fff;
  min-width: 250px;
  padding: 5px;
  z-index: 100;
}
.cstm-email-collapse .all-mail-info a:hover .inner-info {
  display: block;
}
.all-mail-info .inner-info table {
  width: 100%;
  color: #000;
  font-size: 12px;
  font-weight: 500;
}
.all-mail-info .inner-info table th {
  color: #999;
}
.reply-btn .vs-button--text {
  display: flex;
  align-items: center;
}
</style>